import type { AppModule } from "../types";
import { s } from "./strings";

export const projectsTasksModule: AppModule = {
  name: "projects-tasks",
  routes: {
    shell: [
      {
        path: "/projects",
        handle: { title: s.projects },
        lazy: () => import("./pages/ProjectsPage").then((m) => ({ Component: m.ProjectsPage })),
      },
      {
        path: "/projects/alerts",
        handle: { title: s.alertsTitle },
        lazy: () => import("./pages/AlertsPage").then((m) => ({ Component: m.AlertsPage })),
      },
      {
        path: "/projects/:projectId/edit",
        lazy: () => import("./pages/ProjectEditPage").then((m) => ({ Component: m.ProjectEditPage })),
      },
    ],
  },
  sidebar: [
    {
      id: "PROJECTS",
      label: s.projects,
      path: "/projects",
      icon: "projects",
      alt: "View Projects",
      // Hide pages from regular users: Projects (adminOnlyPages bit 1); project managers keep it (spec 3.2).
      visible: (ctx) => {
        if (ctx.isAdmin) return true;
        const mask = Number(ctx.workspaceSettings.adminOnlyPages ?? 0);
        return (mask & 1) === 0 || ctx.role === "PROJECT_MANAGER";
      },
    },
  ],
};
